import React, { useEffect, useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { uInt8ArrayFromBase64 } from '../../lib/utils';

function base64ToBlob(base64: string, mime = 'application/pdf'): Blob {
  const bytes = uInt8ArrayFromBase64(base64);
  return new Blob([bytes], { type: mime });
}

const PdfInlinePreview: React.FC<{ content: string }> = ({ content }) => {
  const src = useMemo(() => {
    try {
      const blob = base64ToBlob(content);
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  }, [content]);

  useEffect(() => {
    if (!src) {
      return;
    }

    return () => {
      URL.revokeObjectURL(src);
    };
  }, [src]);

  if (!src) {
    return (
      <div className="text-sm text-destructive">
        Die PDF-Vorschau konnte nicht geladen werden.
      </div>
    );
  }

  return (
    <div className="w-full h-[70vh]">
      <iframe
        title="PDF Vorschau"
        src={src}
        className="w-full h-full rounded-md border"
      />
    </div>
  );
};

interface DokumentPdfVorschauDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  content: string;
}

export const DokumentPdfVorschauDialog: React.FC<
  DokumentPdfVorschauDialogProps
> = ({ open, onOpenChange, content }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-5xl max-w-5xl h-[95vh]">
        <DialogHeader>
          <DialogTitle>Dokumentvorschau (PDF)</DialogTitle>
        </DialogHeader>
        <PdfInlinePreview content={content} />
      </DialogContent>
    </Dialog>
  );
};
